import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Azkaar } from '../../types';

export type State = Azkaar[];

const initialState: State = [];

export const AzkaarSlice = createSlice({
  name: 'azkaar',
  initialState,
  reducers: {
    onSetAzkaar: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteAzkaar: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetAzkaar, onDeleteAzkaar } = AzkaarSlice.actions;

export default AzkaarSlice.reducer;
